import React from 'react'
import { withTranslation } from "react-i18next";

const ErrorAlert = (props) => {
  const { t } = props;
  return (
    <div className={`alert alert-danger ${props.errorType ? props.errorType : ""}`} role="alert">
      {t(props.error)}
    </div>
  )
}

export default withTranslation()(ErrorAlert);

